import React, { Component } from 'react';
import { connect } from 'react-redux';

import { getMerchantList } from 'redux/app/actionCreators';

const TYPES = ['report:daily-operation-registers', 'report:operations', 'report:monthly-summary-operations'];
const ALL = { sector: 'all', name: 'Все' };

class Select extends Component {
    constructor(props) {
        super(props);
        this.state = {
            options: this.props.options || [],
        };
    }

    componentDidMount() {
        const { link } = this.props;
        const { options } = this.state;
        if (link.length !== 0 && options.length === 0) {
            this.props.getMerchantList(link);
        }
    }

    componentDidUpdate() {
        const { link, merchantList } = this.props;
        const { options } = this.state;
        if (link.length !== 0 && merchantList.isLoading === false && merchantList.isLoaded === true && options.length === 0) {
            this.setState({
                options: merchantList.data.merchanList,
            });
        }
    }

    render() {
        const {
            handleMerchantChange,
            type, link,
            merchantList: {
                isLoading,
                isLoaded,
            },
        } = this.props;
        const { options } = this.state;

        if (link.length === 0) {
            return (
                <select style={{ marginBottom: '10px' }} onChange={handleMerchantChange}>
                    {options.map(option => (
                        <option key={option} value={option}>{option}</option>
                    ))}
                </select>
            );
        }

        return (
            <>
                {isLoading ? <span>...Loading</span> : null}
                {isLoaded ? (
                    <select style={{ marginBottom: '10px' }} onChange={handleMerchantChange}>
                        {TYPES.includes(type) ? (
                            <option value={ALL.sector}>{`${ALL.sector} - ${ALL.name}`}</option>
                        ) : (
                            <option value="">Выберите сектор</option>
                        )}
                        {options.map(option => (
                            <option key={option.sector} value={link.length > 0 ? option.sector : option}>{ link.length > 0 ? `${option.sector} - ${option.name}` : option}</option>
                        ))}
                    </select>
                ) : null}
            </>
        );
    }
}

export default connect(
    state => ({
        merchantList: state.app.merchantList,
    }),
    {
        getMerchantList,
    },
)(Select);
